module.exports = __webpack_public_path__ + "img/23_32.9cab0a1e.png";